import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-100 border-t border-gray-200 py-6">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-600 mb-4 md:mb-0">
            <p>© {currentYear} AWTG Resume Evaluator. All rights reserved.</p>
          </div>
          <div className="text-gray-500 text-sm">
            <p>Developed by AWTG</p>
            <p className="mt-1">Version 1.0.0</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
